// window.__ENV__ (the /config.js the Docker entrypoint writes from the pod env) wins over the build-time
// import.meta.env, so one image serves every environment. An empty runtime value falls back to the build value.
declare global {
    interface Window {
        __ENV__?: Record<string, string | undefined>
    }
}

const buildEnv = import.meta.env as unknown as Record<string, string | undefined>
const runtimeEnv: Record<string, string | undefined> =
    typeof window !== 'undefined' && window.__ENV__ ? window.__ENV__ : {}

const get = (key: string): string => {
    const v = runtimeEnv[key]
    return ((v !== undefined && v !== '' ? v : buildEnv[key]) ?? '') as string
}
const flag = (key: string): boolean => get(key) === 'true'

export const API_URL = get('VITE_REACT_APP_AMS_URL')
export const FORUMS_URL = get('VITE_REACT_APP_FORUMS_URL')
export const LEARNING_URL = get('VITE_REACT_APP_LEARNING_URL')
export const PLAY_AREA_URL = get('VITE_REACT_APP_PLAYAREA_URL')
export const WEBSITE_URL = get('VITE_REACT_APP_WEBSITE_URL')
export const SHOP_URL = get('VITE_REACT_APP_SHOP_URL')
export const ENV = get('VITE_REACT_APP_ENV')
export const GA_GAME_KEY = get('VITE_REACT_APP_GAME_KEY')
export const GA_SECRET_KEY = get('VITE_REACT_APP_SECRET_KEY')
export const GOOGLE_ANALYTICS_ID = get('VITE_REACT_APP_GOOGLE_ANALYTICS_ID')
export const GOOGLE_CLIENT_ID = get('VITE_REACT_APP_GOOGLE_CLIENT_ID')
// Native Google Sign-In returns an id_token whose `aud` is the platform OAuth client,
// not the web client. The BE verifies against these, so they must be sent on native.
export const GOOGLE_CLIENT_ID_ANDROID = get('VITE_REACT_APP_GOOGLE_CLIENT_ID_ANDROID')
export const GOOGLE_CLIENT_ID_IOS = get('VITE_REACT_APP_GOOGLE_CLIENT_ID_IOS')
export const FACEBOOK_APP_ID = get('VITE_REACT_APP_FACEBOOK_APP_ID')
export const FACEBOOK_API_VERSION = get('VITE_REACT_APP_FACEBOOK_API_VERSION')
export const APPLE_CLIENT_ID = get('VITE_REACT_APP_APPLE_CLIENT_ID')
export const APPLE_REDIRECT_URL = get('VITE_REACT_APP_APPLE_REDIRECT_URL')
export const IMAGES_CDN_URL = get('VITE_REACT_APP_IMAGES_CDN_URL')
export const WS_GATEWAY_URL = get('VITE_REACT_APP_WS_GATEWAY')

export const MM_URL = get('VITE_REACT_APP_MM_URL')
export const MM_WS_URL = get('VITE_REACT_APP_MM_WS_URL')
export const GS_URL = get('VITE_REACT_APP_GS_URL')
export const OB_WS_URL = get('VITE_REACT_APP_OB_WS_URL')
export const PUZZLE_URL = get('VITE_REACT_APP_PUZZLE_URL')
export const MISSIONS_URL = get('VITE_REACT_APP_MISSIONS_URL')
export const SHARE_URL = get('VITE_REACT_APP_SHARE_URL')
export const STRIPE_CLIENT_PORTAL = get('VITE_REACT_APP_STRIPE_CLIENT_PORTAL')
export const GTM_ID = get('VITE_REACT_APP_GTM_ID')

export const ENABLE_PUZZLE_PRACTICE_V3 = flag('VITE_REACT_APP_ENABLE_PUZZLE_PRACTICE_V3')
export const ENABLE_DAILY_PUZZLE_V2 = flag('VITE_REACT_APP_ENABLE_DAILY_PUZZLE_V2')
export const ENABLE_DAILY_PUZZLE_FEEDBACK = flag('VITE_REACT_APP_ENABLE_DAILY_PUZZLE_FEEDBACK')
export const ENABLE_COMPONENTS = flag('VITE_REACT_APP_ENABLE_COMPONENTS')
export const ENABLE_PVP_EMOTES = flag('VITE_REACT_APP_ENABLE_PVP_EMOTES')

export const IS_PROD = ENV === 'prod'
export const IS_DEV = ENV === 'dev'
